export default class ModalPremiereClotureController {
	static $inject = ['$scope', '$state', '$stateParams', 'ModalService', 'notification', '$translate', '$filter', '_', '$uibModal', 'moment'];
	constructor($scope, $state, $stateParams, ModalService, notification, $translate, $filter, _, $uibModal, moment) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.ModalService = ModalService;
		this.notification = notification;
		this.$translate = $translate;
		this.$filter = $filter;
		this._ = _;
		this.$uibModal = $uibModal;
		this.moment = moment;
		this.loading = false;
		this.isEdit = false;
	}

	async $onInit() {
		this.dateDebut = this.moment().subtract(1, 'months').endOf('month').format('DD/MM/YYYY');
	}

	async save() {
		const resultat = this.ajusterDateSiPremierJanvier();
		this.ok(resultat);
	}
	ajusterDateSiPremierJanvier() {
		const date = this.moment(this.dateDebut, 'DD/MM/YYYY');
		// 1er janvier (mois 0 = janvier)
		if (date.date() === 1 && date.month() === 0) {
			// 1er janvier (mois 0 = janvier)
			return date.subtract(1, 'day').format('DD/MM/YYYY'); // 31 décembre de l'année précédente
		}

		return date.format('DD/MM/YYYY');
	}

	ok(resultat) {
		this.close({
			$value: resultat
		});
	}
	cancel() {
		this.dismiss();
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
